var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classroom-item",on:{"click":_vm.onClassroomDetail}},[_c('div',{staticClass:"item-name"},[_vm._v(_vm._s(_vm.classroom.name))]),_c('div',{staticClass:"item-subject"},[_vm._v(_vm._s(_vm.classroom.subject.name))]),_c('div',{staticClass:"item-tags"},[_vm._v("Teacher name: "+_vm._s(_vm.classroom.teacher.full_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }